import React, { useEffect, useMemo, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import BrigadeLabelRequestModal from './BrigadeLabelRequestModal'

const BrigadeLabelRequestModalWrapper = ({
  actions = [],
  postUrl,
  shouldReloadOnProfilePage = false,
  shipper,
  shipperIconUrl,
  subheader,
  text,
  type = 'success',
}) => {
  const [isLabelRequestModalOpen, setIsLabelRequestModalOpen] = useState(false)
  const csrfToken = useMemo(
    () => document.querySelector('meta[name="csrf-token"]')?.content,
    [],
  )
  useEffect(() => {
    if (text) {
      setIsLabelRequestModalOpen(true)
    }
  }, [text])

  const handleCloseModal = useCallback(async () => {
    setIsLabelRequestModalOpen(false)

    if (postUrl && csrfToken) {
      try {
        const response = await axios.post(
          postUrl,
          {},
          {
            headers: {
              'X-CSRF-Token': csrfToken,
            },
          },
        )

        if (
          response.status >= 200 &&
          response.status < 300 &&
          shouldReloadOnProfilePage
        ) {
          // Reload the page if on the profile page
          window.location.reload()
        }
      } catch (error) {
        console.error('Error sending Session clear POST request:', error)
      }
    }
  }, [postUrl, csrfToken, shouldReloadOnProfilePage])

  return (
    <BrigadeLabelRequestModal
      actions={actions}
      isOpen={isLabelRequestModalOpen}
      onClose={handleCloseModal}
      shipper={shipper}
      shipperIconUrl={shipperIconUrl}
      subheader={subheader}
      text={text}
      type={type}
    />
  )
}

BrigadeLabelRequestModalWrapper.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      buttonClass: PropTypes.string,
      url: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  postUrl: PropTypes.string.isRequired,
  shouldReloadOnProfilePage: PropTypes.bool,
  shipper: PropTypes.string,
  shipperIconUrl: PropTypes.string,
  subheader: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error']),
}

export default BrigadeLabelRequestModalWrapper
